<template>
  <div class="dashboard-page">
    <div class="row text-right mb-4" v-if="!$session.has('CustomerInfo')">
      <div class="col-md-3 col-12"></div>
      <div class="col-md-2 col-6"><button class="btn w-100" :class="DashboardPage == 0 ? 'ActiveTab' : 'TabBtn'" @click="DashboardPage = 0"> <i class="fad fa-home ml-2"></i> پیشخوان</button></div>
      <div class="col-md-2 col-6"><button class="btn w-100" :class="DashboardPage == 1 ? 'ActiveTab' : 'TabBtn'" @click="DashboardPage = 1"> <i class="fad fa-briefcase ml-2"></i> کارتابل</button></div>
      <!--<div class="col-md-2 col-6"><button :disabled="$session.get('Menu').filter((x) => x.RouteName == 'otherMenus_DashboardSales')[0].isMojaz == 1 ? false : true" class="btn w-100" :class="DashboardPage == 2 ? 'ActiveTab' : 'TabBtn'" @click="DashboardPage = 2">داشبورد فروش</button></div>-->
      <div class="col-md-3 col-12"></div>
    </div>
    <div class="" v-if="DashboardPage == 0" :class="DashboardPage == 0 ? ' animate__animated animate__bounceInLeft' : ''">
      <div class="row">
        <div v-if="$session.has('CustomerInfo')" class="col-12 text-info">
          
          
          <Card>
            <template v-slot:header>
              <h5 class="d-inline">
                <span class="text-info">{{ $session.get('CustomerInfo').CustomerName }}</span> <span class="d-none d-xl-inline">به سیستم مدیریت مشتریان و پشتیبانی پاسارگاد خوش آمدید.</span>
              </h5>
              
            </template>
          </Card>
          <div class="row">
            <div class="col-md-3 col-12 ">
              <div class="Pointer w-100" @click="EducationCenter()">
              <Card class="text-center">
                <template v-slot:content>
                  <i class="fad fa-user-graduate text-secondary fa-3x"></i>
                  <div class="mt-2 formName">آموزش ها</div>
                </template>
              </Card>
            </div>
            </div>
            <div class="col-md-3 col-12 ">
              <div class="Pointer w-100" @click="OnlinePayment()">
              <Card class="text-center">
                <template v-slot:content>
                  <i class="fad fa-coin text-secondary fa-3x"></i>
                  <div class="mt-2 formName">پرداخت های من</div>
                </template>
              </Card>
            </div>
            </div>
            <div class="col-md-3 col-12 ">
              <div class="Pointer w-100" @click="CustomerTicket()">
              <Card class="text-center">
                <template v-slot:content>
                  <i class="fad fa-list text-secondary fa-3x"></i>
                  <div class="mt-2 formName">لیست تیکت ها</div>
                </template>
              </Card>
            </div>
            </div>
            <div class="col-md-3 col-12 ">
              <div class="Pointer w-100" @click="CreateTicket()">
              <Card class="text-center">
                <template v-slot:content>
                  <i class="fad fa-ticket text-secondary fa-3x"></i>
                  <div class="mt-2 formName">ایجاد تیکت</div>
                </template>
              </Card>
            </div>
            </div>
          </div>
        </div>
        <div v-if="$session.has('CustomerInfo')" class="col-12 mb-4">
          <Slider></Slider>
        </div>
        <div v-if="$session.has('CustomerInfo')" class="col-lg-6 col-12">
          <my-ticket-status-customer></my-ticket-status-customer>
        </div>
        <div v-if="!$session.has('CustomerInfo')" class="col-lg-6 col-12">
          <TicketStatus v-if="$session.get('Menu').filter((x) => x.RouteName == 'TicketStatus')[0].isMojaz == 1"></TicketStatus>
          <TicketType v-if="$session.get('Menu').filter((x) => x.RouteName == 'TicketStatus')[0].isMojaz == 1"></TicketType>
          <MyTicketStatus v-if="$session.get('Menu').filter((x) => x.RouteName == 'myTicketStatus')[0].isMojaz == 1"></MyTicketStatus>
        </div>
        <div class="col-lg-6 col-12">
          <Card v-if="$session.get('Menu').filter((x) => x.RouteName == 'CartableContract')[0].isMojaz == 1">
            <template v-slot:content>
              <CartableContract></CartableContract>
            </template>
          </Card>
          <notice-board-dashboard @DataNoticeBoard="DataNoticeBoard" :key="ReloadChild"></notice-board-dashboard>
          <div v-if="!$session.has('CustomerInfo')">
            <!-- <FastAccessAutomation></FastAccessAutomation> -->
          </div>
          <div v-if="!$session.has('CustomerInfo')">
            <!-- <list-process-work-flow-dashboard></list-process-work-flow-dashboard> -->
          </div>

          <Card v-if="!$session.has('CustomerInfo')">
            <template v-slot:header>
              <h4>امتیاز پشتیبانی</h4>
              <hr />
            </template>
            <template v-slot:content>
              <TicketScores></TicketScores>
            </template>
          </Card>
          <Note></Note>
          <Card v-if="!$session.has('CustomerInfo')">
            <template v-slot:header>
              <h4 class="d-inline">نکات کاری</h4>
              <a class="d-inline float-left mx-2 mt-1" href="javascript:;" data-title="ردیف جدید" @click="addToWorkTip()">
                <h4>
                  <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
                </h4>
              </a>
              <hr />
            </template>
            <template v-slot:content>
              <div style="max-height: 300px; overflow-y: scroll">
                <WorkTips></WorkTips>
              </div>
            </template>
          </Card>
        </div>
        <div class="col-12" v-if="$session.get('Menu').filter((x) => x.RouteName == 'TicketDistribution')[0].isMojaz == 1">
          <Card>
            <template slot="header">
              <h4>پراکندگی تیکتها</h4>
              <hr />
            </template>
            <template slot="content">
              <TicketDistrobuTaion></TicketDistrobuTaion>
            </template>
          </Card>
          <!-- <notice-board-dashboard></notice-board-dashboard> -->
        </div>

        <!-- <div class="col-lg-6 col-12">
        <button type="button" @click="notify">Show notification</button>
      </div> -->
      </div>
    </div>
    <div class="" v-if="DashboardPage == 1" :class="DashboardPage == 1 ? ' animate__animated animate__jackInTheBox' : ''">
      <div v-if="!$session.has('CustomerInfo')">
        <div class="row">
          <div class="col-12">
            <Cartabl></Cartabl>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-if="DashboardPage == 2" :class="DashboardPage == 2 ? ' animate__animated animate__jackInTheBox' : ''">
      <div v-if="!$session.has('CustomerInfo')">
        <div class="row">
          <div class="col-12">
            <dashboard-sales></dashboard-sales>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="$store.state.Modal" :Size="'Md'" :InheritanceTheme="true">
      <template v-slot:body>
        <modal-task></modal-task>
      </template>
    </modal>
    <modal v-if="MODAL" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'" @Close="Close">
      <template v-slot:body>
        <div class="row mx-4">
          <div class="col-12">
            <div class="alert alert-secondary">
              <div class="row">
                <div class="col-md-8 col-12">
                  <h6 class="mt-2 mx-3 float-right text-warning" style="display: inline !important">
                    عنوان اعلان : <span>{{ DataNoticeBoardRow.Title }}</span>
                  </h6>
                </div>
                <div class="col-md-4 col-12">
                  <!-- <h6 class="mt-2 mx-3 float-left text-warning" style="display: inline !important">انقضا اعلان : {{ DataNoticeBoardRow.EndDate }}</h6> -->
                </div>
              </div>
            </div>
            <div class="alert alert-secondary">
              <h6 class="text-warning" style="display: inline !important">متن اعلان :</h6>
              <h6 class="mt-3">
                <!-- <textarea readonly disabled class="form-control" v-model="DataNoticeBoardRow.Message" style="background: var(--sidebar-bg-color) !important;border:none;" /> -->
                <div style="white-space: pre-wrap">{{ DataNoticeBoardRow.Message }}</div>
              </h6>
            </div>
            <div class="btn btn-success float-left mb-3" @click="SetReedMessageForCustomer">اعلان را مطالعــــه کرده ام !</div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import Note from './components/Note.vue'
import CartableContract from './components/CartableContract.vue'
import TicketScores from './components/TicketScores.vue'
import TicketStatus from './components/TicketStatus.vue'
import MyTicketStatus from './components/MyTicketStatus.vue'
import TicketDistrobuTaion from './components/TicketDistrobuTaion.vue'
import Slider from './components/Slider.vue'
import NoticeBoardDashboard from './components/NoticeBoardDashboard.vue'
import Modal from '../Modal/Modal.vue'
import ModalTask from '../BnpCrm/Tasks/ModalTask.vue'
import WorkTips from '@/pages/BnpCrm/WorkTips/WorkTipsDashord'
import MyTicketStatusCustomer from './components/MyTicketStatusCustomer.vue'
import TicketType from './components/TicketType.vue'
import ListProcessWorkFlowDashboard from '../BnpAutomation/ListProcessWorkFlowDashboard.vue'
import FastAccessAutomation from './components/BigStat/FastAccessAutomation.vue'
import Cartabl from './components/BigStat/Cartabl.vue'
import DashboardSales from './DashboardSales.vue'
export default {
  name: 'Dashboard',
  components: {
    TicketType,
    Note,
    CartableContract,
    TicketScores,
    TicketStatus,
    MyTicketStatus,
    Card,
    TicketDistrobuTaion,
    Slider,
    NoticeBoardDashboard,
    Modal,
    ModalTask,
    WorkTips,
    MyTicketStatusCustomer,
    ListProcessWorkFlowDashboard,
    FastAccessAutomation,
    Cartabl,
    DashboardSales
},
  data() {
    return {
      DashboardPage: 0,
      ReloadChild: 0,
      IsActiveCash: null,
      DataAxoisMaskShomareOzv: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'TanzimatShobe/b_SetShomareOzvMask',
        Token: this.$session.get('Token'),
      },
      DataAxoisMaskVcode: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'TanzimatShobe/b_SetVCodeMask',
        Token: this.$session.get('Token'),
      },
      DataAxios_TanzimatPublic: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'TanzimatPublic/Get_TanzimatPublic',
        Token: this.$session.get('Token'),
      },
      DataAxoisDoreMali: {
        ArryfildValue: {},
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxois_SarfaslHayeMojaz: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Sarfasl/GetCmbSarfasl',
        Token: this.$session.get('Token'),
      },
      alerts: [
        {
          id: 0,
          title: 'فروش ماه جاری',
          value: 15,
          footer: 'مجموع پیشترفت ... 65 %',
          color: 'danger',
        },
        {
          id: 1,
          title: 'تیکت های پاسخ داده شده',
          value: 20,
          footer: 'Provide required notes',
          color: 'primary',
        },
        {
          id: 2,
          title: 'تیکت های بازه',
          value: 40,
          footer: 'Provide required notes',
          color: 'warning',
        },
      ],
      userId: this.$session.get('UserInfo').tblUserId,
      isCustomer: this.$session.get('CustomerInfo') != undefined && this.$session.get('CustomerInfo').Id > 0 ? true : false,
      MODAL: false,
      DataNoticeBoardRow: {},
    }
  },
  methods: {
    EducationCenter(){this.$router.push({ name: 'EducationCenter'})},
    OnlinePayment(){
      this.$router.push({ name: 'OnlinePayment'})
    },
    addToWorkTip() {
      this.$router.push({ name: 'WorkTips', params: { addRowFromDashbord: true } })
    },
    AllTicket() {
      this.$router.push({ name: 'Tickets' })
    },
    CreateTicket(){
      this.$router.push({ name: 'CreateTicket' })

    },
    CustomerTicket(){
      this.$router.push({ name: 'CustomerTicket' })

    },
    notify() {
      const notification = {
        title: 'Your title',
        options: {
          body: 'This is an example!',
        },
        events: {
          onerror: function () {
            console.log('Custom error event was called')
          },
          onclick: function () {
            console.log('Custom click event was called')
          },
          onclose: function () {
            console.log('Custom close event was called')
          },
          onshow: function () {
            console.log('Custom show event was called')
          },
        },
      }
      this.$notification.show(notification.title, notification.options, notification.events)
    },

    setSetupInformation() {
      this.$PostData_new('get', 'SiteSetting/GetSetupInfo')
        .then((res) => {
          this.$session.set('SetupInfo', res)
        })
        .catch((err) => {
          this.$mySweetDefaultTost('خطا', 'خطا در خواندن اطلاعات اولیه', 'error', 5000)
          // this.$session.clear()
          // this.$router.push({name: 'Login'})
        })
    },

    getUserDepartment() {
      var DataaxiosUpdUser = {
        Action: 'Department/GetUserDep/' + this.userId,
        Method: 'get',
      }

      if (!this.isCustomer) {
        this.$PostData(DataaxiosUpdUser).then((response) => {
          this.$session.set('UserDepartments', response)
        })
      }
    },
    SetSessionOzvMask(mask) {
      this.$session.start()
      this.$session.set('b_SetShomareOzvMask', mask)
    },
    SetSessionVcodeMask(mask) {
      this.$session.start()
      this.$session.set('b_SetVCodeMask', mask)
    },
    Close(value) {
      if (value == true) {
        this.MODAL = false
      }
    },
    DataNoticeBoard(result) {
      this.MODAL = true
      this.DataNoticeBoardRow = result
    },

    SetReedMessageForCustomer() {
      let Model = {
        tblCustomerId: this.$session.get('CustomerInfo').Id,
        tblNoticeBoardId: this.DataNoticeBoardRow.Id,
      }
      var Seen = {
        Action: 'NoticeBoard/ReadMessageCustomer',
        Method: 'Post',
        ArryfildValue: Model,
      }
      this.$PostData(Seen).then((data) => {
        this.MODAL = false
        this.ReloadChild = true
      })
      this.ReloadChild++
    },
  },

  mounted() {
    if (this.$session.get('UserInfo').dashboardTask && !this.$session.has('DashboardTask')) {
      this.$store.state.Modal = true
      this.$session.set('DashboardTask', true)
    }

    var DataaxiosUpdUser = {
      Action: 'Authentication/b_UpdateUser',
      Method: 'Post',

      ArryfildValue: {
        UserId: this.$session.get('UserInfo').tblUserId,
      },
    }
    this.$PostData(DataaxiosUpdUser).then((response) => {
      this.$store.state.LastLoginTime = response[0].LastLoginTime
    })

    if (!this.$session.has('CustomerInfo')) {
      var DataAlarm = {
        Action: 'Alarm/GetAlarmUser',
        Method: 'Post',
        ArryfildValue: {
          UserId: this.$session.get('UserInfo').tblUserId,
        },
      }
      this.$PostData(DataAlarm).then((res) => {
        this.$cookies.remove('UserAlarm')
        if (res.length > 0) {
          this.$cookies.set('UserAlarm', JSON.stringify(res))
        }
      })
    }

    this.getUserDepartment()
    if (this.$store.state.IsActiveCash != undefined && this.$store.state.IsActiveCash == true) {
      let MaskOzv
      let MaskVcode
      this.$PostData(this.DataAxoisMaskShomareOzv)
        .then(function (data) {
          MaskOzv = data.MaskShomareOzv
        })
        .finally(() => {
          this.SetSessionOzvMask(MaskOzv)
        })
      this.$PostData(this.DataAxoisMaskVcode)
        .then(function (data) {
          MaskVcode = data.MaskVcode
        })
        .finally(() => {
          this.SetSessionVcodeMask(MaskVcode)
        })
      this.DataAxios_TanzimatPublic.ArryfildValue = {
        id: 1,
      }
      this.$PostData(this.DataAxios_TanzimatPublic).then((dataTanzimatPublic) => {
        this.$store.state.TanzimatPublic = dataTanzimatPublic
        var t = [
          {
            tarixShoroFromTarixSanad: dataTanzimatPublic.tarixShoroFromTarixSanad,
            emkanManfiShodanGhabelBardashtPas: dataTanzimatPublic.emkanManfiShodanGhabelBardashtPas,
            moarefiVamBaPassManfi: dataTanzimatPublic.moarefiVamBaPassManfi,
            ezafeVarizOnNextGhest: dataTanzimatPublic.ezafeVarizOnNextGhest,
            hazfBarnamehHayeeKeGhablAzYekTarixHastand: dataTanzimatPublic.hazfBarnamehHayeeKeGhablAzYekTarixHastand,
            tedadGerd: dataTanzimatPublic.tedadGerd,
            tblComboId309RoundMethodAghsat: dataTanzimatPublic.tblComboId309RoundMethodAghsat,
            mabEdgham2GhestAxar: dataTanzimatPublic.mabEdgham2GhestAxar,
            tedadGerdKarmozdTashilat: dataTanzimatPublic.tedadGerdKarmozdTashilat,
            sendTashilatSMS: dataTanzimatPublic.sendTashilatSMS,
            tblSMSTemplateIdDarPar: dataTanzimatPublic.tblSMSTemplateIdDarPar,
            changeDateInSanad: dataTanzimatPublic.changeDateInSanad,
            tblSMSTemplateIdTashilat: dataTanzimatPublic.tblSMSTemplateIdTashilat,
            tblAzaNoeFilter: dataTanzimatPublic.tblAzaNoeFilter,
            sendSmsMandeToMoaref: dataTanzimatPublic.sendSmsMandeToMoaref,
            tblSMSTemplateIdMandeMoaref: dataTanzimatPublic.tblSMSTemplateIdMandeMoaref,
            sendDarParSMS: dataTanzimatPublic.sendDarParSMS,
            sendSoodSepSms: dataTanzimatPublic.sendSoodSepSms,
            tblSMSTemplateIdSoodSeporde: dataTanzimatPublic.tblSMSTemplateIdSoodSeporde,
            darsadEdgham2GhestAxar: dataTanzimatPublic.darsadEdgham2GhestAxar,
            sendPardaxtGhestSms: dataTanzimatPublic.sendPardaxtGhestSms,
            tblSMSTemplateIdPardaxtGhest: dataTanzimatPublic.tblSMSTemplateIdPardaxtGhest,
            mablaghErsalSms: dataTanzimatPublic.mablaghErsalSms,
            tedadGerdBime: dataTanzimatPublic.tedadGerdBime,
            tblComboId309RoundMethodBime: dataTanzimatPublic.tblComboId309RoundMethodBime,
            asnadZemanatiBedehkar: dataTanzimatPublic.asnadZemanatiBedehkar,
            sendDarParForModir: dataTanzimatPublic.sendDarParForModir,
            tblSMSTemplateIdDarParForModir: dataTanzimatPublic.tblSMSTemplateIdDarParForModir,
            mablaghErsalSmsForModir: dataTanzimatPublic.mablaghErsalSmsForModir,
            mobilesForModir: dataTanzimatPublic.mobilesForModir,
            isSendSmsTajmieForFrmDarPar: dataTanzimatPublic.isSendSmsTajmieForFrmDarPar,
            sendVosolCheckSms: dataTanzimatPublic.sendVosolCheckSms,
            tblSMSTemplateIdVosolCheck: dataTanzimatPublic.tblSMSTemplateIdVosolCheck,
            sendBargashtCheckBeShaxsSms: dataTanzimatPublic.sendBargashtCheckBeShaxsSms,
            tblSMSTemplateIdBargashtCheckBeShaxs: dataTanzimatPublic.tblSMSTemplateIdBargashtCheckBeShaxs,
            sendSmsInfoTashilatToMoaref: dataTanzimatPublic.sendSmsInfoTashilatToMoaref,
            tblSMSTemplateIdInfoTashilatToMoaref: dataTanzimatPublic.tblSMSTemplateIdInfoTashilatToMoaref,
          },
        ]

        this.$store.state.b_SabtSandDaem = t
      })
      this.DataAxois_SarfaslHayeMojaz.ArryfildValue = {
        tblGrpId: this.$session.get('UserInfo').tblGrpId,
        tblShobeId: this.$session.get('UserInfo').tblShobeId,
      }
      this.$PostData(this.DataAxois_SarfaslHayeMojaz).then((dataSarfaslHayeMojaz) => {
        this.$store.state.SarfaslHayeMojaz = dataSarfaslHayeMojaz.filter((x) => x.TblComboIdVazeiatZirGrp15 == 4046)
      })
      this.DataAxoisDoreMali.Action = 'TblCombo/GetDoreMali?Id=' + this.$session.get('UserInfo').tblShobeId
      let DoreMaliData
      this.$PostData(this.DataAxoisDoreMali)
        .then(function (data) {
          DoreMaliData = data
        })
        .finally(() => {
          this.$store.state.DoreMaliData = DoreMaliData
          this.$session.set('DoreMaliData', DoreMaliData)
        })
    }
    this.setSetupInformation()
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSetting.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      this.IsActiveCash = result.data.IsActiveCash
    })
  },
}
</script>
<style scoped>
.ActiveTab {
  background: var(--logo-color);
  color: #ffffff;
}
.TabBtn {
  border: 1px solid var(--logo-color);
  color: var(--logo-color);
}

@keyframes shake {
  0% { transform: translateX(0); }
  35% { transform: translateX(-5px) rotate(-5deg); }
  65% { transform: translateX(5px) rotate(5deg); }
  100% { transform: translateX(0); }
}

#Card:hover i,#Card:hover .formName{
  transition: 0.5s;
  animation: shake 0.6s ;
  color:var(--logo-color) !important;
}
</style>
<style src="./Dashboard.scss" lang="scss" />
